<template>
  <section>
    <!--工具条-->

    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 20px auto 0px 15px; float: left; width: 1000px"
    ></toolbar>
    <div>
      <el-button
        type="primary"
        @click="onClickfatherDatas"
        style="
          line-height: 0;
          width: 118px;
          height: 30px;
          background: #007aff;
          border-radius: 3px;
          float: right;
          text-align: center;
          margin: 23px 50px 0 0;
          float: right;
        "
        >返回上一页</el-button
      >
    </div>
    <el-col :span="24">
      <el-select
        v-model="status"
        @change="changeStatus"
        placeholder="请选择状态"
        id="inputselect"
        style="width: 200px; margin: 0px auto 10px 15px"
      >
        <el-option label="待审核" value="1"></el-option>
        <el-option label="审核通过" value="2"></el-option>
        <el-option label="驳回" value="3"></el-option>
      </el-select>
    </el-col>
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column type="index" width="80" align="center"></el-table-column>
      <el-table-column
        prop="QuestionTitle"
        label="问题"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="评论内容"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="CustomerName"
        label="查看评价人昵称"
        width
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>

      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.Status == 1"
            class="SpanList"
            @click="handleEdit(scope.row)"
            >驳回</span
          >
          <span
            v-if="scope.row.Status == 1"
            class="SpanList"
            @click="handleGood(scope.row)"
            >通过</span
          >
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetCommentListByPage,
  CommentInfoDelete,
  UpdateCommentStatus,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      status: null,
      QuesTionId: null,
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      total: 0,
      page: 1,
      pagesize: 15,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CommentContent: "",
        CateName: "",
        Content: "",
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    changeStatus(val) {
      this.status = val;
      this.getModules();
    },
    // 返回组列表
    onClickfatherDatas() {
      this.$router.push("/Question/HotQuestion");
      // this.$router.push({
      //   path: "/Course/courseData_index",
      //   query: { Id: id },
      // });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = {
        PageIndex: this.page,
        PageSize: this.pagesize,
        Name: this.filters.name,
        QuestionId: this.QuesTionId,
        Status: this.status,
      };
      this.listLoading = true;

      //NProgress.start();
      GetCommentListByPage(para).then((res) => {
        if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
        }
        //NProgress.done();
      });
    },
    //显示编辑界面
    handleEdit(row) {
      this.$confirm("确认该问题通过吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: row.Id, status: 3 };
          UpdateCommentStatus(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    handleGood(row) {
      this.$confirm("确认该问题通过吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: row.Id, status: 2 };
          UpdateCommentStatus(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //删除
    handleDel(Id) {
      // let row = this.currentRow;
      // // if (!row) {
      // //   this.$message({
      // //     message: "请选择要删除的一行数据！",
      // //     type: "error",
      // //   });

      // //   return;
      // // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: Id };
          CommentInfoDelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    editSubmit: function () {
      this.$confirm("确认该问题通过吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let paras = Object.assign({}, this.editForm);
          console.log(paras);
          let para = { Id: paras.Id, status: 1 };
          QuestionInfoUpdate(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //驳回
    editSubmitno: function () {
      //RejectQuestionStatus
      this.$confirm("确认驳回该问题吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let paras = Object.assign({}, this.editForm);
          let para = { Id: paras.Id, status: 2 };
          para.then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.QuesTionId = this.$route.query.Id;
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
